var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('transferir-chat'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row noventay3",class:{menuCambiado: _vm.asesor.rol_id==4}},[_c('div',{staticClass:"relativo col-2 pl-0 col-xx-1"},[_c('Menu')],1),_c('div',{staticClass:"col-10 col-xx-11"},[_c('router-view')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }